import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSalesStatus extends Layout {
    sourceSalesStatus: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
